import {
  Info,
  HelpCircle,
  BookMarked,
  BookText,
  Wifi,
  Phone,
  Bookmark,
  ScrollText,
  BookOpen,
  FileText,
  Car,
  CarTaxiFront,
  Plane,
  TrainFront,
  Home,
  Building2,
  Tent,
  Caravan,
  BedDouble,
  Brush,
  Luggage,
  Backpack,
  Hand,
  Users,
  Accessibility,
  Fuel,
  Utensils,
  Landmark,
  ShoppingBag,
  Dumbbell,
  Bike,
  PawPrint,
  TreePine,
  TreePalm,
  Camera,
  MapPinned,
  MapPin,
  Map,
  Clock,
  Heart,
  Leaf,
  Activity,
  CloudSun,
  Star,
  ShieldCheck,
  CircleCheck,
  Tag,
  LayoutGrid,
  List,
  ListChecks,
  FileCode,
  type LucideIcon,
} from 'lucide-react';

const GUIDEBOOK_ICONS: {name: string; icon: LucideIcon}[] = [
  {name: 'info', icon: Info},
  {name: 'help-circle', icon: HelpCircle},
  {name: 'book-marked', icon: BookMarked},
  {name: 'book-text', icon: BookText},
  {name: 'wifi', icon: Wifi},
  {name: 'phone', icon: Phone},
  {name: 'bookmark', icon: Bookmark},
  {name: 'scroll-text', icon: ScrollText},
  {name: 'book-open', icon: BookOpen},
  {name: 'file-text', icon: FileText},
  {name: 'car', icon: Car},
  {name: 'car-taxi-front', icon: CarTaxiFront},
  {name: 'plane', icon: Plane},
  {name: 'train-front', icon: TrainFront},
  {name: 'home', icon: Home},
  {name: 'building-2', icon: Building2},
  {name: 'tent', icon: Tent},
  {name: 'caravan', icon: Caravan},
  {name: 'bed-double', icon: BedDouble},
  {name: 'brush', icon: Brush},
  {name: 'luggage', icon: Luggage},
  {name: 'backpack', icon: Backpack},
  {name: 'hand', icon: Hand},
  {name: 'users', icon: Users},
  {name: 'accessibility', icon: Accessibility},
  {name: 'fuel', icon: Fuel},
  {name: 'utensils', icon: Utensils},
  {name: 'landmark', icon: Landmark},
  {name: 'shopping-bag', icon: ShoppingBag},
  {name: 'dumbbell', icon: Dumbbell},
  {name: 'bike', icon: Bike},
  {name: 'paw-print', icon: PawPrint},
  {name: 'tree-pine', icon: TreePine},
  {name: 'tree-palm', icon: TreePalm},
  {name: 'camera', icon: Camera},
  {name: 'map-pinned', icon: MapPinned},
  {name: 'map-pin', icon: MapPin},
  {name: 'map', icon: Map},
  {name: 'clock', icon: Clock},
  {name: 'heart', icon: Heart},
  {name: 'leaf', icon: Leaf},
  {name: 'activity', icon: Activity},
  {name: 'cloud-sun', icon: CloudSun},
  {name: 'star', icon: Star},
  {name: 'shield-check', icon: ShieldCheck},
  {name: 'circle-check', icon: CircleCheck},
  {name: 'tag', icon: Tag},
  {name: 'layout-grid', icon: LayoutGrid},
  {name: 'list', icon: List},
  {name: 'list-checks', icon: ListChecks},
  {name: 'file-code', icon: FileCode},
];

const LUCIDE_ICON_MAP: Record<string, LucideIcon> = Object.fromEntries(
  GUIDEBOOK_ICONS.map(({name, icon}) => [name, icon]),
);

const LEGACY_ICON_MAP: Record<string, string> = {
  guideBookMainIcon: 'book-marked',
  guidebookIcon: 'book-text',
  'open-book': 'book-open',
  location: 'map-pin',
  arrowLocation: 'map-pinned',
  greetHand: 'hand',
  bag: 'backpack',
  attractions: 'landmark',
  apartments: 'building-2',
  restaurant: 'utensils',
  weather: 'cloud-sun',
  'about-people': 'users',
  'info-filled': 'info',
  questionCircle: 'help-circle',
  'question-circle': 'help-circle',
  checkedBadgeTwo: 'shield-check',
  checkedBadge: 'circle-check',
  sheet: 'file-text',
  layout: 'layout-grid',
  'dot-list': 'list',
  'check-list': 'list-checks',
};

function normalizeLegacyIconName(name: string): string {
  return LEGACY_ICON_MAP[name] ?? name;
}

function getLucideIcon(name: string): LucideIcon | undefined {
  return LUCIDE_ICON_MAP[normalizeLegacyIconName(name)];
}

export {getLucideIcon};
